import React from 'react';
import { LegalLayout, LegalSection } from '../components/page/LegalLayout';
const sections: LegalSection[] = [{
  heading: 'Introduction',
  blocks: [{
    type: 'p',
    text: 'Welcome to Zano. These Terms govern your use of our website and services. By using Zano, you agree to comply with these Terms, including our Data Use Restrictions, Intellectual Property policies, and Prohibited Activities.'
  }]
}, {
  heading: 'Account Registration and Onboarding',
  blocks: [{
    type: 'p',
    text: 'To access the Zano platform:'
  }, {
    type: 'list',
    items: ['Fill out the form on our “Request an Invite” page.', 'Upon review, you will either be approved or rejected.', 'Approved users will receive an invite email with a link to create an account.', 'During account creation, users provide personal details (name, job title - optional), business details (company name, contact information), and upload a roster of influencers.']
  }]
}, {
  heading: 'Payments and Billing',
  blocks: [{
    type: 'list',
    items: ['All users must select a plan and provide credit card details.', 'The first month is free; subsequent months or years are billed per the chosen plan.', 'Payments are processed via Stripe, with the first payment due four weeks after starting the trial.', 'Payments continue monthly or yearly on the same date, and receipts are available via email and within your account. We use Stripe to handle all payments and invoices.']
  }]
}, {
  heading: 'GDPR Compliance',
  blocks: [{
    type: 'p',
    text: 'Zano adheres to GDPR guidelines by:'
  }, {
    type: 'list',
    items: ['Processing personal data based on consent, contract, legal obligations, or legitimate interests.', 'Granting users rights, including access, rectification, erasure, and data portability.', 'Implementing security measures to protect personal data and notifying users of any data breaches.', 'Removing all personal, influencer, and agency data upon account deletion.']
  }]
}, {
  heading: 'Data Use Restrictions',
  blocks: [{
    type: 'p',
    text: 'All data on Zano, including influencer profiles, contact details, and platform insights, is provided solely for internal use by approved users.'
  }, {
    type: 'p',
    text: 'Prohibited Uses: Users are strictly prohibited from copying, scraping, sharing, or distributing any data obtained through Zano to unauthorized third parties or entities. Unauthorized use of data, including the redistribution or commercial exploitation of data, may lead to account termination and potential legal action.'
  }, {
    type: 'p',
    text: 'Limited License: Users are granted a limited, non-exclusive, non-transferable license to use the platform’s data solely for their agency’s influencer marketing needs and not for resale or redistribution.'
  }]
}, {
  heading: 'User Content',
  blocks: [{
    type: 'p',
    text: 'Users may upload and manage rosters within the platform. Users retain intellectual property rights to content they upload, but no royalty-free or exclusive license is granted to other users.'
  }]
}, {
  heading: 'Communications and Newsletter Subscription',
  blocks: [{
    type: 'p',
    text: 'By filling out the "Request an Invitation" form, you consent to receiving email communications from Zano, including updates, newsletters, and promotional content. You may opt out of these communications at any time by selecting "Unsubscribe" in our emails.'
  }]
}, {
  heading: 'Intellectual Property and Licensing for Platform Data',
  blocks: [{
    type: 'p',
    text: 'While users retain ownership of their uploaded data, Zano holds all rights to platform content, data, features, and insights not provided by users. Accessing the Zano platform does not grant users a license to share or distribute this data outside their organization.'
  }]
}, {
  heading: 'Prohibited Activities',
  blocks: [{
    type: 'p',
    text: "Users agree to avoid any activities that interfere with the Zano platform's security or integrity. Prohibited activities include, but are not limited to:"
  }, {
    type: 'list',
    items: ['Data scraping, data mining, or the use of automated tools to extract information from the platform.', 'Attempting to reverse engineer or otherwise access proprietary aspects of Zano.', 'Sharing login credentials or permitting unauthorized access to any Zano data or features.']
  }, {
    type: 'p',
    text: 'Violations may result in account suspension, termination, and legal action.'
  }]
}, {
  heading: 'Confidentiality',
  blocks: [{
    type: 'p',
    text: 'Zano’s data, including agency roster details, influencer details, contact information, and platform insights, is confidential and intended solely for use by authorized users within their agency. Unauthorized sharing of confidential data with outside parties is a violation of these Terms and may lead to account suspension or termination.'
  }]
}, {
  heading: 'Changes to Terms',
  blocks: [{
    type: 'p',
    text: 'Zano reserves the right to modify these Terms. Any changes will be communicated to users via email. Continued use of the platform after receiving notification constitutes acceptance of the updated Terms.'
  }]
}, {
  heading: 'Limitation of Liability',
  blocks: [{
    type: 'p',
    text: 'Zano is not liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of, or inability to use, the platform.'
  }]
}, {
  heading: 'Governing Law',
  blocks: [{
    type: 'p',
    text: 'These Terms are governed by the laws of The Netherlands, without regard to its conflict of law provisions.'
  }]
}, {
  heading: 'Contact Us',
  blocks: [{
    type: 'p',
    text: 'For questions about these Terms or your use of the Zano platform, please contact support@zanoplatform.com.'
  }]
}];
export const TermsOfService = () => {
  return <LegalLayout title="Terms of Service" subtitle="Read our terms below to learn more about your rights and responsibilities as a user." updated="November 3, 2024" intro='Please read our Terms of Service ("Terms") to understand your rights and responsibilities when using Zano. By accessing or using the Zano platform, you agree to be bound by these Terms. If you disagree with any part, you may not access the website or use the service.' sections={sections} data-id="element-2832" data-mp="3gwimhk5672m1" />;
};